import { AxiosResponse } from 'axios';
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { getNoneEmptyProviderCategories } from '../../../Services/ProviderServices';


export type ProviderCategory = {
    id:number,
    displayName: string,
    iconName?: string,
}

export type ProviderCategoryData = ProviderCategory[];


export function usePublicProviderList(){

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<ProviderCategoryData>([]);
    const [updateCounter, setUpdateCounter] = useState<number>(0);

    useEffect(() => {
        _fetchData();
    }, []);

    const _fetchData: () => void = () => {
        if(!isLoading){
            setIsLoading(true);
        }
        getNoneEmptyProviderCategories(false).then((result) => {
            setIsLoading(false);
            let response: AxiosResponse<unknown, ProviderCategoryData> = result as AxiosResponse;
            if (response.status === 200 && response.data) {
                let data = response.data as ProviderCategoryData;
                setData(data);
                setUpdateCounter((prevData)=>{return prevData + 1;});
            }
        }, (error) => {
            setIsLoading(false);
            console.log(error);
        });
    }

    return [isLoading, data, updateCounter] as const;
}